export type B3DesignSystemBrand = 'b3';
export type B3DesignSystemMode = 'light' | 'dark';

const DEFAULT_BRAND: B3DesignSystemBrand = 'b3';
const DEFAULT_MODE: B3DesignSystemMode = 'light';

export const B3_DESIGN_SYSTEM_LOGOS = {
  b3Logo: 'assets/b3-design-system/logos/b3-logo.svg',
  b3LogoClearspace: 'assets/b3-design-system/logos/b3-logo-clearspace.svg',
} as const;

export function initializeB3DesignSystemTheme(
  brand: B3DesignSystemBrand = DEFAULT_BRAND,
  mode: B3DesignSystemMode = DEFAULT_MODE,
): void {
  if (typeof document === 'undefined') {
    return;
  }

  document.body.setAttribute('data-brand', brand);
  document.body.setAttribute('data-mode', mode);
}
